import { render } from "./tcShopManage.vue?vue&type=template&id=9795f04e"
import script from "./tcShopManage.vue?vue&type=script&lang=js"
export * from "./tcShopManage.vue?vue&type=script&lang=js"

import "./tcShopManage.vue?vue&type=style&index=0&id=9795f04e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__